<template>
  <div>
    <UploadedBackendFiles
      :backendFiles="data.files"
      @removeFiles="removeFile"
    />
    <div
      v-for="(file, index) in data.newFiles"
      :key="index"
    >
      <v-row
        class="file-container xPadding"
        align="center"
        justify="center"
      >
        <v-col
          cols="11"
          class="noYPadding pr-0"
        >
          <VFile
            v-model="data.newFiles[index]"
            outlined
            :label="$t('forms.labels.file')"
            :isEdition="isEditabled"
            :rules="{
              mimes: acceptedFormats,
              size: 10000000
            }"
            readonly="readonly"
            cyData="selectFile"
            prependIcon=""
            @input="updateData"
          />
        </v-col>
        <v-col
          cols="1"
          class="noYPadding p-0 minusAndPlus"
        >
          <v-btn
            v-if=" data.newFiles.length > 1 && (!data.newFiles[index] || ( data.newFiles[index] ) )"
            icon
            class="ml-3 add-btn px-0"
            @click="deleteFile(index)"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
          <v-btn
            v-if="data.newFiles[index] && (data.newFiles.length - 1) === index"
            icon
            class="ml-3 add-btn px-0"
            @click="addEmptyFile"
          >
            <v-icon>
              mdi-plus
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <p class="xPadding">
      {{ $t(`technicalFile.cooling.step4.notes`) }}
    </p>


    <v-row class="xPadding">
      <v-col class="noYPadding">
        <VTextarea
          v-model="data.note"
          class="text-field-transparent"
          :rules="{ max: 300 }"
          outlined
          readonly="readonly"
          flat
          data-cy="networkNote"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import VFile from '@/components/shared/widgets/forms/VuetifyInputs/VFile';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import { cloneDeep } from 'lodash';
import UploadedBackendFiles from '@/components/shared/UploadedBackendFiles.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        VFile,
        VTextarea,
        UploadedBackendFiles,
    },
    props: {
        networkInfos: {
            type: Object,
            default: () => {},
        },
        parentNode: {
            type: String,
            default: () => '',
        },
    },
    data() {
        return {
            data: {},
            isEditabled: false,
            acceptedFormats: [
                'image/jpeg',
                'image/gif',
                'image/png',
            ],
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
        ]),
        readonly() {
            return !this.hasPermission('techFiles.edit');
        },
    },
    watch: {
        networkInfos: {
            handler() {
                this.data = { ...this.data, newFiles: [null], ...cloneDeep(this.networkInfos) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData(isFile) {
            if (isFile) this.isEditabled = true;
            this.$emit('sendData', { networkInfos: this.data });
        },
        addEmptyFile() {
            if (this.data.newFiles[this.data.newFiles.length - 1] !== null && this.data.newFiles.length < 9) { // Limited for 9 files to add
                this.data.newFiles.push(null);
            }
        },
        async downloadFile(image) {
            const { data } = await this.$rq.downloadFile(image.id);
            this.$utils.saveFileOnDisk(data, image.link.fileName);
        },
        async removeFile(imageId) {
            await this.$rq.deleteFile(imageId);
            // eslint-disable-next-line no-param-reassign
            this.data.files = this.data.files.filter(file => {
                // eslint-disable-next-line no-underscore-dangle
                const id = file.id || file._id;
                return id !== imageId;
            });
            this.$emit('sendData', { networkInfos: this.data });
        },
        deleteFile(index) {
            this.data.newFiles.splice(index, 1);
        },
    },
};
</script>
<style lang="scss" scoped>
 .file-container {
    display: flex;
    padding: 0;
 }
 .xPadding{
  padding: 0 6rem;
}
p{
  font-size: 16px;
  font-weight: 500;//MEDIUM
}
.image a {
    text-decoration: underline;
}
.noYPadding {
    padding-bottom: 0px;
    padding-top: 0px;
}
.add-btn{
  margin-top: -30px;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
.minusAndPlus{
  display: flex;
  flex-direction: row;
}
</style>
